<template>
    <div v-if="user" :class="{dimmed_no_click: loader}">
        <div v-if="allUsersCount !== 0">
            <va-row :gutter="12">
                <va-column :lg="12" :sm="12">
                    <va-table hover fullWidth class="datatable">
                        <table :dir="getDirectionStatus">
                            <thead>
                                <tr>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        {{ _('Name') }}
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">{{
                                            _('Profile') }}
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">{{
                                        
                                        _('Email') }}
                                    </th>

                                    <th v-if="type == 'manager' || type == 'user'"
                                        :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">{{
                                        _('Departments') }}
                                    </th>

                                    <th v-if="user.get('type') == 'admin'"
                                        :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">{{
                                        _('Email Verification') }}
                                    </th>
                                    <th v-if="user.get('type') == 'admin' || user.get('type') == 'manager'"
                                        :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">{{
                                        _('User Activation') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="theUser in perPageUsers">
                                    <td style="max-width: 200px;"
                                        v-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager'))"
                                        :class="{rtlTd: getSystemLanguage != 'english'}"><a style="cursor:pointer;"
                                            @click="$router.push('/users/' + theUser.id)">{{theUser.get('name')}}</a>
                                    </td>

                                    <td style="max-width: 200px;"><img v-if="theUser.get('profilePic')"
                                            :src="theUser.get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')"
                                            alt="profile" width="32px" height="32px" style="border-radius: 100px;">
                                        <img width="32px" height="32px" style="border-radius: 100px;" v-else
                                            src="@/assets/emptyProfile.jpg" alt="profile">
                                    </td>
                                    <td style="max-width: 200px;" :class="{rtlTd: getSystemLanguage != 'english'}">
                                        {{ theUser.get('username') }}
                                    </td>

                                    <td style="max-width: 200px;" v-if="type == 'manager' || type == 'user'">
                                        {{ getDepartmentsLabels(theUser.get('departments')) }}
                                    </td>
                                    <td style="max-width: 200px;" v-if="user.get('type') == 'admin'">
                                        <va-button
                                            v-if="theUser.get('emailVerified') == null || theUser.get('emailVerified') == false"
                                            :disabled="loading" type="primary"
                                            @click.native="sendEmailVerification(theUser)">
                                            {{_('Verify User')}}
                                        </va-button>
                                        <va-lozenge v-else type="success">{{ _('Verified') }}</va-lozenge>
                                    </td>
                                    <td style="max-width: 200px;"
                                        v-if="user.get('type') == 'admin' || user.get('type') == 'manager'">
                                        <va-button v-if="theUser.get('is_active') == true" :disabled="loading"
                                            type="danger" @click.native="userActivation(theUser, false)">
                                            {{_('Deactivate')}}
                                        </va-button>

                                        <va-button v-if="!theUser.get('is_active')" :disabled="loading" type="primary"
                                            @click.native="userActivation(theUser, true)">
                                            {{_('Activate')}}
                                        </va-button>
                                    </td>

                                </tr>
                            </tbody>
                        </table>

                    </va-table>
                </va-column>
            </va-row>
            <va-row :gutter="12">
                <va-column :lg="12" :sm="12">
                    <div style="display: flex">
                        <!-- <v-page :class="{no_click: allUsersCount==0}" :key="$route.path" :total-row="allUsersCount"
                            @page-change="paginate"></v-page> -->
                        <my-page :key="$route.path" :class="{no_click: allUsersCount == 0}" :total-row="allUsersCount"
                            @page-change="paginate" :pageSizeMenu="[10, 20, 50, 100]">
                        </my-page>

                        <va-button style="margin-left: 10px" @click.native="paginate({PageNumber: page})">
                            <va-icon type="sync-alt"></va-icon>
                        </va-button>
                    </div>
                </va-column>
            </va-row>
        </div>
        <div v-else class="deadCenter">
            <p>{{ _('No user available') }}</p>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import MyPage from '../components/Page.vue'

    export default {

        props: ['type'],

        components: {
            'my-page': MyPage
        },

        data() {
            return {
                newPassword: '',
                page: 1,
                allUsersCount: null,
                perPageUsers: [],
                allSearchedUsers: 0,
                searchedUsers: [],
                searchPagination: false,
                loader: false,
                user_type: '',
            }
        },

        watch: {
            async '$route'(to, from) {
                await this.fetchings()
            }
        },


        computed: {
            ...mapGetters(["user", "getSystemLanguage", "getDirectionStatus", "loading", "getUserDepartmentsFromState"]),
        },


        methods: {

            getDepartmentsLabels(departments) {
                var labels = [];
                if (departments) {
                    for (let i = 0; i < departments.length; i++) {
                        const department = departments[i];
                        labels.push(this.g_getLabel(department))
                    }
                    return labels.join(', ')
                } else return this._('N/A')
            },

            async userActivation(theUser, val) {
                if (theUser != null) {

                    this.loader = true;
                    theUser.set('is_active', val)
                    await theUser.save()
                        .then(async res => {
                            await this.g_newActivity({
                                label_english: theUser.get('name'),
                                label_pashto: theUser.get('name'),
                                label_dari: theUser.get('name'),
                                type: 'user',
                                action: val ? 'activateUser' : 'deactivateUser',
                                url: '/users/' + theUser.id,
                                createdBy: this.user.id,
                                to: null,
                                category: null,
                                department: res.get('department'),
                                class: 'User',
                                reference_id: res.id
                            })
                            await this.fetchUsers(1);
                            this.$notify({
                                group: 'foo',
                                text: this._(val ? 'User was activated' : 'User was deactivated'),
                                duration: 4000,
                                position: 'top left',
                                type: 'success'
                            });
                            this.loader = false;
                        }).catch(e => {
                            this.$notify({
                                group: 'foo',
                                title: this._('System Error'),
                                text: this._(val ? 'Failed to activate' : 'Failed to deactivate'),
                                duration: 4000,
                                position: 'top left',
                                type: 'success'
                            });
                            this.loader = false;
                        });
                }
            },

            async sendEmailVerification(theUser) {
                this.$store.commit('setLoading', true)
                await axios.post(
                    'https://parse.nepa.gov.af/parse/verificationEmailRequest',
                    {
                        "email": theUser.get('username')
                    },
                    {
                        "headers":
                        {
                            "X-Parse-Application-Id": "nepa",
                            "X-Parse-Master-Key": "ag33israr3698",
                            "Content-Type": "application/json"
                        }
                    }
                ).then(res => {
                    this.$store.commit('setLoading', false)
                    this.$notify({
                        group: 'foo',
                        text: this._('Verifiaction email was sent'),
                        duration: 4000,
                        position: 'top left',
                        type: 'success'
                    });

                }).catch(e => {
                    this.$store.commit('setLoading', false)
                    this.$notify({
                        group: 'foo',
                        text: this._('Failed to send verification email'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                })
            },

            async searchUser(searchingText) {
                if (searchingText) {
                    var conditions = [];
                    this.user_type = this.g_checkIfUserIsAdminOrManagerByRole()
                    var orTemp = [];
                    let regex = new RegExp(`^.*${searchingText}.*`, "i");
                    orTemp.push(new Parse.Query('User').matches('email', regex))
                    orTemp.push(new Parse.Query('User').matches('name', regex))
                    conditions.push(Parse.Query.or(...orTemp))

                    conditions.push(new Parse.Query('User').equalTo('type', this.type))
                    if (this.user_type == 'manager' && this.type != 'guest') {
                        var department_or_temp = [];
                        if (this.getUserDepartmentsFromState) {
                            for (let i = 0; i < this.getUserDepartmentsFromState.length; i++) {
                                const department = this.getUserDepartmentsFromState[i];
                                department_or_temp.push(new Parse.Query('User').equalTo('departments', department))
                            }
                        }
                        if (department_or_temp.length != 0) {
                            conditions.push(Parse.Query.or(...department_or_temp))
                        }
                    }

                    var mainQuery = Parse.Query.and(...conditions);
                    mainQuery.descending('createdAt')
                    this.perPageUsers = await mainQuery.find();
                    this.allUsersCount = this.perPageUsers.length
                }
            },

            async fetchUsers(pageNumber) {
                var conditions = [];
                this.user_type = this.g_checkIfUserIsAdminOrManagerByRole()
                conditions.push(new Parse.Query('User').equalTo('type', this.type))

                if (this.user_type == 'manager' && this.type != 'guest') {
                    var department_or_temp = [];
                    if (this.getUserDepartmentsFromState) {
                        for (let i = 0; i < this.getUserDepartmentsFromState.length; i++) {
                            const department = this.getUserDepartmentsFromState[i];
                            department_or_temp.push(new Parse.Query('User').equalTo('departments', department))
                        }
                    }
                    if (department_or_temp.length != 0) {
                        conditions.push(Parse.Query.or(...department_or_temp))
                    }
                }

                var limit = 10;
                if (this.$route && this.$route.query && this.$route.query['perPage']) {
                    limit = parseInt(this.$route.query['perPage'])
                } else {
                    limit = 10
                }

                var mainQuery = Parse.Query.and(...conditions);
                mainQuery.skip((pageNumber - 1) * limit)
                mainQuery.limit(limit)
                mainQuery.descending('createdAt')
                this.perPageUsers = await mainQuery.find();
            },

            async fetchUsersCount() {
                var conditions = [];
                this.user_type = this.g_checkIfUserIsAdminOrManagerByRole()
                conditions.push(new Parse.Query('User').equalTo('type', this.type))

                if (this.user_type == 'manager' && this.type != 'guest') {
                    var department_or_temp = [];
                    if (this.getUserDepartmentsFromState) {
                        for (let i = 0; i < this.getUserDepartmentsFromState.length; i++) {
                            const department = this.getUserDepartmentsFromState[i];
                            department_or_temp.push(new Parse.Query('User').equalTo('departments', department))
                        }
                    }
                    if (department_or_temp.length != 0) {
                        conditions.push(Parse.Query.or(...department_or_temp))
                    }
                }

                var mainQuery = Parse.Query.and(...conditions);
                this.allUsersCount = await mainQuery.count();
            },

            async paginate(page) {
                this.page = page.pageNumber
                this.$store.commit('setLoading', true)
                await this.fetchUsersCount();
                await this.fetchUsers(page.pageNumber)
                this.$store.commit('setLoading', false)

            },

            async fetchings() {
                this.$store.commit('setLoading', true)
                await this.fetchUsersCount();
                await this.fetchUsers(1)
                this.$store.commit('setLoading', false)
            }
        },


        async mounted() {
            await this.fetchings()
        }
    };
</script>

<style>
    .user_wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
</style>